import { render, staticRenderFns } from "./Brevo.vue?vue&type=template&id=41ab426d"
import script from "./Brevo.vue?vue&type=script&lang=js"
export * from "./Brevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports